import en from './auth.en';

const enConfig = { en };

export default enConfig;
